import React, { useEffect } from "react";
import './assets/CSS/bootstrap-5-48-LGO.css';
import { HashRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Layout from "./components/MainComponents/Layout/layout.component";
import Login from "./components/MainComponents/Login/login.component";
import ClientDashboard from './components/ClientSide/clientSideOutlet.component';
import 'react-datepicker/dist/react-datepicker.css';
import { AccountProvider } from "./Contexts/main.context";

// Main routing logic with auth check
const AppRouter = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const userToken = localStorage.getItem("LGOUser");

        // Allow access to login page without redirect
        if (location.pathname === "/login") return;

        if (userToken) {
            try {
                const decoded = jwtDecode(userToken);
                const currentTime = Math.floor(Date.now() / 1000);

                // Token expired
                if (decoded.exp && decoded.exp < currentTime) {
                    localStorage.removeItem("LGOUser");
                    navigate("/login");
                }
            } catch (error) {
                localStorage.removeItem("LGOUser");
                navigate("/login");
            }
        } else {
            navigate("/login");
        }
    }, [location.pathname, navigate]);

    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Layout />} />
            <Route path="/clientDashboard" element={<ClientDashboard />} />
        </Routes>
    );
};

// Final export with AccountProvider and HashRouter
const App = () => (
    <AccountProvider>
        <HashRouter>
            <AppRouter />
        </HashRouter>
    </AccountProvider>
);

export default App;
